import React from 'react';
import { toast } from 'sonner';
import { BookmarkPlus } from 'lucide-react';
import { adminApi } from '../../lib/adminAuth';

export default function TemplatePicker({ templates, onPick, draft, onSaved }) {
  const pick = (id) => { const t = templates.find((x) => x.id === id); if (t) onPick(t); };
  const saveDraft = async () => {
    const name = window.prompt('Template name');
    if (!name) return;
    try {
      await adminApi.post('/api/admin/push/templates', { name, title: draft.title, body: draft.body, category: 'office' });
      toast.success('Template saved'); onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save'); }
  };
  return (
    <div className="flex gap-2">
      <select defaultValue="" onChange={(e) => { pick(e.target.value); e.target.value = ''; }} data-testid="push-template-select"
        className="flex-1 h-10 px-3 rounded-lg border border-slate-200 text-sm bg-white">
        <option value="" disabled>Use a template…</option>
        {['festival', 'holiday', 'office'].map((c) => (
          <optgroup key={c} label={c === 'office' ? 'Office notices' : c === 'holiday' ? 'Holidays' : 'Festivals'}>
            {templates.filter((t) => t.category === c).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </optgroup>
        ))}
      </select>
      <button type="button" onClick={saveDraft} disabled={!draft.title.trim() || !draft.body.trim()} title="Save as template" data-testid="push-save-template-button"
        className="h-10 px-3 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 disabled:opacity-40 inline-flex items-center gap-1 text-sm">
        <BookmarkPlus className="w-4 h-4" /> Save
      </button>
    </div>
  );
}
